import { useState, useEffect } from 'react';
import fb from '~/api/core/facebook';

// TODO: Add loading and error states
function usePotentialReach(accountId, accessToken, targeting, targetingReady) {
  const [monthly, setMonthly] = useState(null);
  const [daily, setDaily] = useState(null);

  useEffect(() => {
    // TODO: Incorporate status to track fetching data
    if (accessToken && accountId && targetingReady) {
      const path = `${accountId}/delivery_estimate`;
      const params = {
        optimization_goal: 'NONE',
        targeting_spec: targeting,
      };

      fb(path, 'GET', params)
        .then((e) => {
          const { estimate_dau, estimate_mau } = e.data[0];

          setDaily(estimate_dau);
          setMonthly(estimate_mau);
        });
    }
  }, [targeting, accountId, accessToken, targetingReady]);

  return { daily, monthly };
}

export default usePotentialReach;
